import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { InputProps } from './input.component';
import Input from './input.component';

export interface HfInputProps extends InputProps {
  control: Control<FieldValues>;
}

export default function HfInput({
  control,
  name = '',
  label,
  type,
  value,
  placeholder,
  readOnly,
  required,
  onChange,
  onChangeEvent,
  fieldValueConverter,
  onFocus,
  disabled,
  debounceTime,
  validations,
  labelStyles,
  inputStyles,
  trimWhitespace = true,
  min,
  enableDebounce,
  inputRef,
}: HfInputProps) {
  return (
    <OdinController
      name={name}
      defaultValue={value}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <Input
            name={name}
            label={label}
            type={type}
            value={value}
            placeholder={placeholder}
            error={error?.message}
            readOnly={readOnly}
            required={required}
            onChange={onChange}
            onChangeEvent={onChangeEvent}
            onFocus={onFocus}
            disabled={disabled}
            debounceTime={debounceTime}
            validations={validations}
            labelStyles={labelStyles}
            inputStyles={inputStyles}
            trimWhitespace={trimWhitespace}
            min={min}
            enableDebounce={enableDebounce}
            inputRef={inputRef}
          />
        );
      }}
    />
  );
}
